import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Card, CardMedia, CardContent, Typography, Box, Button, IconButton,
} from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import QuizOutlinedIcon from '@mui/icons-material/QuizOutlined';
import { setOnDetail, onTutorialPage } from '../../../redux/slices/tutorialSlice';
import StudentQuizAPIs from 'utilities/api/StudentQuizAPIs';
import fallbackImg from '../../../utilities/dummy_assets/login.jpg';

const getImageUrl = (img) => {
  if (!img) return fallbackImg;
  if (img.startsWith('http')) return img;
  return `${process.env.REACT_APP_API_BASE_URL?.replace(/\/$/, '')}${img}`;
};

const getDescriptionPreview = (description) => {
  const words = description.split(' ');
  return words.length <= 10 ? description : words.slice(0, 10).join(' ') + '...';
};

const GridTutorialCard = ({ item, onQuizOpen }) => {
  const dispatch = useDispatch();
  const [quizzes, setQuizzes] = useState([]);

  useEffect(() => {
    StudentQuizAPIs.QuizzesForModule(item.id)
      .then((data) => setQuizzes(data || []))
      .catch((err) => console.error('Failed to fetch quizzes:', err));
  }, [item.id]);

  const handleInfoClick = (id) => dispatch(setOnDetail({ onDetail: true, id }));
  const handleWatchNowClick = (id) => {
    dispatch(setOnDetail({ onDetail: true, id }));
    dispatch(onTutorialPage(true));
  };

  return (
    <Card sx={{
      position: 'relative',
      border: '1px solid #B5B5B5',
      borderRadius: '30px',
      overflow: 'hidden',
      boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
      maxWidth: '400px',
    }}>
      <Box sx={{ position: 'relative', padding: '15px', paddingBottom: '0px' }}>
        <CardMedia
          component="img"
          image={getImageUrl(item.image)}
          alt={item.name}
          sx={{ width: '100%', height: '250px', borderRadius: '15px' }}
        />
        <IconButton
          sx={{
            position: 'absolute', color: '#273F77', top: '20px', right: '20px',
            padding: '2px', backgroundColor: 'white', borderRadius: '50%',
            '&:hover': { backgroundColor: 'rgba(255,255,255,1)' },
          }}
          onClick={() => handleInfoClick(item.id)}
        >
          <InfoOutlinedIcon />
        </IconButton>
      </Box>

      <CardContent>
        <Typography variant="h6" component="div">{item.name}</Typography>
        <Typography variant="body2" color="text.secondary">
          {item.videos.length} Videos
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ marginTop: '8px' }}>
          {getDescriptionPreview(item.description)}
        </Typography>

        <Box sx={{ display: 'flex', gap: 1, marginTop: '8px' }}>
          <Button
            variant="contained"
            startIcon={<PlayArrowIcon />}
            onClick={() => handleWatchNowClick(item.id)}
            sx={{
              flexGrow: 1, fontSize: '12px', textTransform: 'none',
              backgroundColor: '#E79A2B', color: '#FFF', borderRadius: '8px',
              boxShadow: '0 2px 8px rgba(231,154,43,0.35)',
              '&:hover': { backgroundColor: '#d4891f' },
            }}
          >
            Watch Now
          </Button>

          {quizzes.length > 0 && (
            <Button
              variant="outlined"
              startIcon={<QuizOutlinedIcon />}
              onClick={() => onQuizOpen(quizzes, item.name)}
              sx={{
                flexGrow: 1, fontSize: '12px', textTransform: 'none',
                borderColor: '#273F77', color: '#273F77', borderRadius: '8px',
                '&:hover': { backgroundColor: 'rgba(39,63,119,0.05)' },
              }}
            >
              Take Quiz
            </Button>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

export default GridTutorialCard;

// import React from 'react';
// import { useDispatch } from 'react-redux';
// import { Card, CardMedia, CardContent, Typography, Box, Button, IconButton } from '@mui/material';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
// import { setOnDetail, onTutorialPage } from '../../../redux/slices/tutorialSlice';

// const GridTutorialCard = ({ item }) => {
//   const dispatch = useDispatch();

//   const handleInfoClick = (id) => {
//     console.log('handleInfoClick', id);
//     dispatch(setOnDetail({ onDetail: true, id }));
//   };

//   const handleWatchNowClick = (id) => {
//     dispatch(setOnDetail({ onDetail: true, id }));
//     dispatch(onTutorialPage(true));
//   };

//   return (
//     <Card
//       sx={{
//         position: 'relative',
//         border:'1px solid #B5B5B5',
//         borderRadius: '30px',
//         overflow: 'hidden',
//         boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
//         maxWidth:'400px',
//       }}
//     >
//       <Box
//         sx={{
//           position: 'relative',
//           padding: '15px',
//           paddingBottom:'0px',
//         }}
//       >
//         <CardMedia
//           component="img"
//           image={item.image}
//           alt={item.topic}
//           sx={{
//             width: '100%',
//             height: '250px',
//             borderRadius: '15px',
//           }}
//         />
//         <Box
//           sx={{
//             position: 'absolute',
//             bottom: '10px',
//             left: '22px',
//             padding: '2px 8px',
//             backgroundColor: 'white',
//             border: '1px solid #2196f3',
//             borderRadius: '12px',
//             color: '#2196f3',
//             fontSize: '12px',
//           }}
//         >
//           <Typography variant="body2">{item.tag}</Typography>
//         </Box>
//         <IconButton
//           sx={{
//             position: 'absolute',
//             color:'#273F77',
//             top: '20px',
//             right: '20px',
//             padding:'2px',
//             backgroundColor: 'white',
//             borderRadius: '50%',
//             '&:hover': {
//               backgroundColor: 'rgba(255, 255, 255, 1)',
//             },
//           }}
//           onClick={() => handleInfoClick(item.id)}
//         >
//           <InfoOutlinedIcon />
//         </IconButton>
//       </Box>
//       <CardContent>
//         <Typography variant="h6" component="div">
//           {item.topic}
//         </Typography>
//         <Typography variant="body2" color="text.secondary">
//           {item.no_of_videos} Videos ・ {item.no_of_time}
//         </Typography>
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             marginTop: '8px',
//           }}
//         >
//           <Button
//             variant="contained"
//             startIcon={<PlayArrowIcon />}
//             onClick={() => handleWatchNowClick(item.id)}
//             sx={{
//               flexGrow: 1,
//               margin: '0 4px',
//               fontSize: '12px',
//               textTransform: 'none',
//               backgroundColor: '#E79A2B',
//               color: '#FFF',
//               '&:hover': {
//                 backgroundColor: '#f9c346',
//               },
//             }}
//           >
//             Watch Now
//           </Button>
//           <Button
//             variant="outlined"
//             startIcon={<PlaylistAddIcon />}
//             sx={{
//               flexGrow: 1,
//               margin: '0 4px',
//               fontSize: '12px',
//               textTransform: 'none',
//               borderColor: '#000',
//               color: '#000',
//               '&:hover': {
//                 borderColor: '#000',
//               },
//             }}
//           >
//             Add to watchlist
//           </Button>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// export default GridTutorialCard;
